import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

/**
 * Builds a more specific "no permissions" message with link for no-permission.hbs
 * This was initially created for reports when the user does not
 * have the "View Individual Records" permission (#41667) but this could easily
 * be made more generic if other areas had a need for a similar message
 *
 * @param responseJSON
 * @returns a message letting the user know which permission they need to have
 * granted, with a link to the dataset they need the permission for
 */
function noPermissionSpecificMessage(responseJSON) {
	let message
	const args = _.get(responseJSON, 'arguments', [])
	if (args[0] === 'common.security.missing.reports.datasets.view') {
		let messageCode = args[0]
		let permission = args[1] && i18n.highlight(args[1])
		let datasetLabel = args[2]
		let datasetId = args[3]
		let link =
			`<a class="sp-navigate text-link" href="datasets/${datasetId}">${datasetLabel}</a>`
		message = i18n.get(messageCode, permission, link)
		return message
	}
}

export default noPermissionSpecificMessage
noPermissionSpecificMessage.__filename__ = 'components/no-permission-specific-message.js'
